var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 7.80863 2 5.71294 3.05041 4.26718C3.38964 3.80026 3.80026 3.38964 4.26718 3.05041C5.71294 2 7.80863 2 12 2C16.1914 2 18.2871 2 19.7328 3.05041C20.1997 3.38964 20.6104 3.80026 20.9496 4.26718C22 5.71294 22 7.80863 22 12C22 16.1914 22 18.2871 20.9496 19.7328C20.6104 20.1997 20.1997 20.6104 19.7328 20.9496C18.2871 22 16.1914 22 12 22C7.80863 22 5.71294 22 4.26718 20.9496C3.80026 20.6104 3.38964 20.1997 3.05041 19.7328C2 18.2871 2 16.1914 2 12ZM12.0011 6.70312C9.07747 6.70312 6.70703 9.07357 6.70703 11.9972C6.70703 14.9209 9.07747 17.2914 12.0011 17.2914C14.9248 17.2914 17.2953 14.9209 17.2953 11.9972C17.2953 9.07357 14.9248 6.70312 12.0011 6.70312ZM12.0011 15.3061C10.1773 15.3061 8.69233 13.8211 8.69233 11.9972C8.69233 10.1721 10.1773 8.68842 12.0011 8.68842C13.825 8.68842 15.31 10.1721 15.31 11.9972C15.31 13.8211 13.825 15.3061 12.0011 15.3061ZM18.3953 6.307C18.3953 6.69661 18.0794 7.01244 17.6898 7.01244C17.3002 7.01244 16.9844 6.69661 16.9844 6.307C16.9844 5.9174 17.3002 5.60156 17.6898 5.60156C18.0794 5.60156 18.3953 5.9174 18.3953 6.307Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.404464f2c97fb7b9c059cbb20c77d954.svg";
export { ForwardRef as ReactComponent };